import apiRoutes from '@constants/apiRoutes';
import baseApi from '@services/api';
import {
  NotificationData,
  TransformedGetAllNotificationRes,
  TransformedGetUnreadNotificationRes
} from '@DStypes/notifications';

const notifications = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUnreadNotifications: builder.query<TransformedGetUnreadNotificationRes, any>({
      query: (id: string) =>
        `${apiRoutes.notifications}/all/?user_id=${id}&is_unread=True`,
      providesTags: ['notificationsList'],
      transformResponse: (messages: NotificationData[]) =>
        ({
          unreadMessages: messages
        })
    }),
    getAllNotifications: builder.query<TransformedGetAllNotificationRes, any>({
      query: (id: string) => `${apiRoutes.notifications}/all/?user_id=${id}`,
      providesTags: ['allNotificationsList'],
      transformResponse: (messages: NotificationData[]) => ({
        allMessages: messages
      })
    }),
    updateNotificationAsRead: builder.mutation<
      any,
      { id: string; message_id: string[] }
    >({
      query: ({ id, message_id }) => ({
        url: `${apiRoutes.notifications}/read/?user_id=${id}`,
        method: 'PUT',
        body: {
          message_id
        }
      }),
      invalidatesTags: ['notificationsList', 'allNotificationsList']
    })
  })
});

export const {
  useGetUnreadNotificationsQuery,
  useGetAllNotificationsQuery,
  useUpdateNotificationAsReadMutation
} = notifications;
